// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/DimensionValue.yaml
// Generated: 2026-05-31T18:49:09.410Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateDimensionValue, UpdateDimensionValue, DimensionValue } from '@/types/finance/DimensionValue';

/**
 * DimensionValue Service
 * CRUD operations for DimensionValue via the ABP API.
 */
export const dimensionValueService = new EntityService<DimensionValue, CreateDimensionValue, UpdateDimensionValue>(
  '/api/finance/dimensionvalue',
  'DimensionValue',
);
